import { TFunction } from 'react-i18next';

const mappErrorCategoryToMessage = (
  t: TFunction<('addInsurance' | 'common')[]>,
  category: any,
  insuranceType?: any
) => {
  const errorMapping = {
    invalid: {
      header: t('addInsurance:errors.invalid.header'),
      body: t('addInsurance:errors.invalid.body'),
    },
    cant_reach_carrier: {
      header: t('addInsurance:errors.cantReachCarrier.header'),
      body: t('addInsurance:errors.cantReachCarrier.body'),
    },
    insurance_not_active: {
      header: t('addInsurance:errors.insuranceNotActive.header'),
      body: t('addInsurance:errors.insuranceNotActive.body'),
    },
    flags: {
      header: t('addInsurance:errors.flags.header', { insurance_type: insuranceType }),
      body: t('addInsurance:errors.flags.body'),
    },
  };
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return errorMapping[category];
};

export { mappErrorCategoryToMessage };
